import styled from 'styled-components'
import LogoTmovParceiros from '../../../../shared/assets/images/logo_parceiros.svg'
import { Tokens } from '@tmov/design-system/theme/types'
export { Button, TextField, Heading, Typography } from '@tmov/design-system'

const { colors } = Tokens.eixods

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`

export const Header = styled.img.attrs({
  src: LogoTmovParceiros,
  alt: 'Logo tmov parceiros',
})`
  width: 360px;
  height: 60px;
  object-fit: cover;
  margin: 40px auto 0;
`

export const Form = styled.form`
  width: 100%;
  max-width: 1000px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 24px;
  box-sizing: border-box;
  & > div:not(div:first-of-type) {
    display: flex;
    flex-wrap: wrap;
    gap: 28px;
    h4 {
      width: 100%;
      color: ${colors.brand.secondary[100]};
    }
  }
  & > div:first-of-type {
    h3 {
      color: ${colors.brand.secondary[100]};
    }
    p {
      color: ${colors.neutral.grey[70]};
    }
  }
`

export const Action = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 24px;
  button {
    width: 120px;
  }
`
